import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';

import { Header } from './components/header/header';

import { Footer } from './components/footer/footer';

import { CookieConsent } from './components/cookie-consent/cookie-consent';

import { NotFoundComponent } from './components/not-found/not-found';

import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb';

import { BrandLogo } from './components/brand-logo/brand-logo';

import { MenubarModule } from 'primeng/menubar';

import { AvatarModule } from 'primeng/avatar';

import { MenuModule } from 'primeng/menu';

import { InputGroupModule } from 'primeng/inputgroup';

import { SelectModule } from 'primeng/select';

import { DatePickerModule } from 'primeng/datepicker';

import { CardModule } from 'primeng/card';

import { ChipModule } from 'primeng/chip';

import { TagModule } from 'primeng/tag';

import { TabsModule } from 'primeng/tabs';

import { TextareaModule } from 'primeng/textarea';

import { TableModule } from 'primeng/table';

import { SkeletonModule } from 'primeng/skeleton';

import { DialogModule } from 'primeng/dialog';

import { ToastModule } from 'primeng/toast';

import { CheckboxModule } from 'primeng/checkbox';

import { PasswordModule } from 'primeng/password';

import { InputMaskModule } from 'primeng/inputmask';

import { ButtonModule } from 'primeng/button';

import { ReactiveFormsModule } from '@angular/forms';



const PRIMENG_MODULES = [

  ButtonModule,

  MenubarModule,

  AvatarModule,

  MenuModule,

  InputGroupModule,

  SelectModule,

  DatePickerModule,

  CardModule,

  ChipModule,

  TagModule,

  TabsModule,

  TextareaModule,

  TableModule,

  SkeletonModule,

  DialogModule,

  ToastModule,

  CheckboxModule,

  PasswordModule,

  InputMaskModule

]



const SHARED_COMPONENTS = [

  Header,

  Footer,

  CookieConsent,

  NotFoundComponent,

]



@NgModule({

  declarations: [

    ...SHARED_COMPONENTS

  ],

  imports: [

    CommonModule,

    ReactiveFormsModule,

    RouterModule,

    BreadcrumbComponent,

    BrandLogo,

    ...PRIMENG_MODULES,

  ],

  exports: [

    ...SHARED_COMPONENTS,

    ...PRIMENG_MODULES,

    BreadcrumbComponent,

    BrandLogo,

    CommonModule,

    ReactiveFormsModule,

    RouterModule,

  ]

})

export class SharedModule { }

